import { errorToJson } from '../utils'

// 业务API包装器
export async function bizApiWrapper<T>(
  apiPromise: Promise<T>
): Promise<{ data?: T; err?: boolean; message?: string; code?: number }> {
  try {
    const data = await apiPromise
    return { data }
  } catch (error) {
    return errorToJson(error)
  }
}
